import { ROLES } from "utils/helpers/enums/roles.enum";

export class LoginByAppleDTO{
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    uid: string = '';
    role: ROLES
    profileType: string = 'leader';

    constructor(data: Partial<LoginByAppleDTO> = {}){
        Object.assign(this,data);
    }
}

